import { render, staticRenderFns } from "./SecondWorks.vue?vue&type=template&id=00524489&scoped=true&"
import script from "./SecondWorks.vue?vue&type=script&lang=js&"
export * from "./SecondWorks.vue?vue&type=script&lang=js&"
import style0 from "./SecondWorks.vue?vue&type=style&index=0&id=00524489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00524489",
  null
  
)

export default component.exports